
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import TheNavbar from '@/components/TheNavbar.vue'
import TheFooter from '@/components/TheFooter.vue'
import Analytics from '@/components/Analytics.vue'

export default {
  name: 'App',
  components: {
    ElConfigProvider,
    TheNavbar,
    TheFooter,
    Analytics
  },
  setup() {
    const route = useRoute()
    
    // 在登录页面不显示头部导航
    const showHeader = computed(() => route.name !== 'login')
    
    return {
      showHeader,
      zhCn
    }
  }
}
